/**
 * CRONOGRAMA-MSP (09/10/2026) — duas frases da ficha da obra, puras (testáveis sem tela).
 */
import type { UltimaImportacao } from '@/lib/projetos-store';

/**
 * Item 5: a mig 511 (31/08) preservou o campo extinto "Interesse do cliente" como TEXTO, e o Ganho copiou as
 * observações do card para a descrição da obra — então o cabeçalho mostrava "Interesse do cliente (campo removido em
 * 31/08/2026): CFTV PERIMETRAL". Não é descrição: é informação antiga do cadastro. Separa as duas; ❌ não apaga nada
 * (o original continua nas observações do card; medido em 09/10: 1 obra, a #6).
 */
export const MARCA_DA_INFORMACAO_ANTIGA = 'Interesse do cliente (campo removido em 31/08/2026):';

export function separarInformacaoAntiga(descricao: string | null | undefined): { descricao: string | null; antiga: string[] } {
  if (!descricao) return { descricao: null, antiga: [] };
  const antiga: string[] = [];
  const resto: string[] = [];
  for (const bloco of descricao.split(/\n\s*\n/)) {
    if (bloco.trim().startsWith(MARCA_DA_INFORMACAO_ANTIGA)) antiga.push(bloco.trim());
    else resto.push(bloco);
  }
  const texto = resto.join('\n\n').trim();
  return { descricao: texto || null, antiga };
}

/** Dias corridos entre a data (Brasília) da importação e `hoje` ('AAAA-MM-DD'). */
export function diasDesdeImportacao(emIso: string, hoje: string): number {
  const dataBR = new Date(Date.parse(emIso) - 3 * 3_600_000).toISOString().slice(0, 10);
  return Math.round((Date.parse(`${hoje}T00:00:00Z`) - Date.parse(`${dataBR}T00:00:00Z`)) / 86_400_000);
}

const hojeBR = () => new Date(Date.now() - 3 * 3_600_000).toISOString().slice(0, 10);

/** Item 11: "Atualizado hoje, por Oscar" · "Atualizado ontem" · "Atualizado há 12 dias, por Oscar". */
export function atualizadoHa(u: UltimaImportacao, hoje: string = hojeBR()): string {
  const d = diasDesdeImportacao(u.emIso, hoje);
  const quando = d <= 0 ? 'hoje' : d === 1 ? 'ontem' : `há ${d} dias`;
  const primeiroNome = u.porNome?.trim().split(/\s+/)[0];
  return `Atualizado ${quando}${primeiroNome ? `, por ${primeiroNome}` : ''}.`;
}
